<template>
  <v-container>
    <ModuleBar :title="schema == 'new' ? 'NUEVO EMPLEADO' : 'EDITAR EMPLEADO'" />

    <v-card outlined>
      <v-card-title>
        <template v-if="schema != 'new' && employee">
          <v-icon v-if="employee.is_lider" color="orange" size="30">
            mdi-crown-outline
          </v-icon>
          <v-btn :loading="loadingPayroll" @click="openDialogPayroll" v-if="employee.payroll" text color="primary"
            outlined :class="employee.is_lider ? `ml-2` : `ml-0`">
            ver nomina
          </v-btn>
          <v-btn :loading="loadingAsingPayroll" v-else text @click="openDialogAdminPayroll" color="primary" outlined
            :class="employee.is_lider ? `ml-2` : `ml-0`">
            asignar nomina
          </v-btn>
        </template>

        <v-spacer></v-spacer>
        <v-btn text outlined color="primary" @click="openDialogVehicules">vehiculos</v-btn>
        <v-btn class="ml-2" text outlined color="primary" @click="openDialogTools">herramientas</v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-row>
            <v-col cols="12" class="d-flex justify-center" v-if="schema != 'new'">
              <v-avatar size="150" @click="openDialogPhoto" v-if="photoUrl">
                <v-img :src="photoUrl" :lazy-src="thumbUrl">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="primary" width="2"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Nombres" v-model="names" :rules="rulesNames" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Procedencia" v-model="lastNames" :rules="rulesLastNames" />
            </v-col>

            <v-col cols="12" md="6">
              <v-select label="Provincia" :items="locations" v-model="locationId" item-value="id" item-text="name"
                :rules="rulesLocation" :loading="loadingLocation" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Distrito o localidad" v-model="district" :rules="rulesDistrict" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Direccion" v-model="address" :rules="rulesAddress" />
            </v-col>

            <v-col cols="12" md="6">
              <v-select label="Categoria" :items="categories" v-model="categoryId" item-value="id" item-text="name"
                :rules="rulesCategories" :loading="loadingCategories" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Sueldo" type="number" v-model="salary" :rules="rulesSalary" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="Apodo" v-model="avatar" />
            </v-col>
            <v-col cols="12" md="6">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="date" label="Fecha de ingreso" prepend-icon="mdi-calendar" readonly
                    v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Responsabilidad" v-model="responsibility" :rules="rulesResponsibility" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Recomendado por" v-model="recommended" />
            </v-col>
            <v-col cols="12" md="6">
              <v-file-input label="Foto" show-size :rules="rulesPhoto" accept="image/png, image/jpeg, image/bmp"
                v-model="photo" />
            </v-col>

            <v-col cols="12" md="6">
              <v-select label="Estado" :items="statusItems" v-model="status" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="red" v-if="schema == 'edit'" @click="deleteEmployee"
          :loading="loadingDelete">eliminar</v-btn>
        <v-spacer />
        <v-btn v-if="schema == 'edit'" @click="closeDialogEmployee" text>cancelar</v-btn>
        <v-btn :loading="loadingProcess" @click="process" text color="primary">
          {{ schema == "new" ? "guardar" : "editar" }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogPhoto" width="800">
      <v-card>
        <v-card-text>
          <v-img :src="photoUrl" :lazy-src="thumbUrl" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVehicules" width="800">
      <v-card>
        <v-card-text>
          <vehicules :click="click" @vehiculesIds="vehiculesIds" :employeeId="employeeId" :schema="schema" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTools" width="800">
      <v-card>
        <v-card-text>
          <tools :click="clickTool" :schema="schema" :employeeId="employeeId" @toolsIds="toolsIds" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPayroll" width="800" persistent>
      <v-card>
        <v-card-text>
          <payroll-form :payroll="payroll" title="EDITAR NOMINA" schema="edit" :click="clickPayroll"
            @closeDialogPayroll="closeDialogPayroll" @deleteOneEmployee="deleteOneEmployee" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAdminPayroll" width="800">
      <v-card>
        <v-card-title>Lista de nominas</v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="d-flex justify-center">
              <v-progress-circular v-if="loadingPayrolls" indeterminate color="primary" width="2" size="60" />
              <v-list v-else-if="payrolls.length" class="mt-5">
                <template v-for="(item, index) in payrolls">
                  <v-list-item :key="index" v-if="payrolls" @click="selectPayroll(item)">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{item.employees.find(x => x.is_lider == 1).names}} /
                        {{item.employees.find(x => x.is_lider == 1).last_names}} /
                        {{item.employees.find(x => x.is_lider == 1).avatar}}
                      </v-list-item-title>
                      <v-list-item-subtitle>{{ item.location.name }}</v-list-item-subtitle>
                      <v-list-item-subtitle>MONTO DE GASTO: {{ item.amount_bill
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle>CANTIDAD DE EMPLEADOS: {{ item.employees.length ? item.employees.length : 0
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index != payrolls.length - 1" :key="`div${index}`" />
                </template>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import ModuleBar from "../General/ModuleBar.vue";
import Vehicules from "../Forms/VehiculesList";
import Tools from "../Forms/ToolsList.vue";
import PayrollForm from "./payrollForm.vue";

export default {
  props: ["schema", "employee"],

  components: { ModuleBar, Vehicules, Tools, PayrollForm },

  mounted() {
    this.loadLocations();
    this.findEmployessCategories();
    this.loadData();
    this.loadPayroll();
  },

  data() {
    return {
      district: "",
      loadingAsingPayroll: false,
      payrolls: [],
      loadingPayrolls: false,
      dialogAdminPayroll: false,
      clickPayroll: 0,
      loadingPayroll: false,
      payroll: null,
      dialogPayroll: false,
      address: "",
      categoryId: 0,
      loadingCategories: false,
      categories: [],
      toolIds: "",
      salary: 0,
      vehiIds: "",
      clickTool: 0,
      dialogTools: false,
      click: 0,
      dialogVehicules: false,
      locations: [],
      loadingLocation: false,
      locationId: 0,
      status: 1,
      statusItems: [
        { text: "ACTIVO", value: 1 },
        { text: "INACTIVO", value: 0 },
      ],
      dialogPhoto: false,
      loadingDelete: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu2: false,
      modal: false,
      names: "",
      lastNames: "",
      responsibility: "",
      recommended: "",
      avatar: "",
      photo: null,
      photoUrl: "",
      thumbUrl: "",
      valid: false,
      loadingProcess: false,
      employeeId: 0,
      rulesNames: [
        (value) => (value && value.length > 0) || "Ingrese los nombres",
      ],
      rulesLastNames: [
        (value) => (value && value.length > 0) || "Ingrese la procedencia",
      ],
      rulesResponsibility: [
        (value) => (value && value.length > 0) || "Ingrese la responsabilidad",
      ],
      rulesLocation: [
        (value) => (value && value > 0) || "Seleccione la ubicacion",
      ],
      rulesSalary: [
        (value) =>
          (value && value.toString().length > 0) || "Ingrese el sueldo",
      ],
      rulesCategories: [
        (value) => (value && value > 0) || "Seleccione la categoria",
      ],

      rulesPhoto: [
        (value) =>
          !value ||
          value.size < 4000000 ||
          "La foto no puede pesar mas de  4 Mb!",
      ],

      rulesAddress: [(value) => (value && value.length > 0) || "Ingrese la direccion",],

      rulesDistrict: [(value) => (value && value.length > 0) || "Ingrese el distrito o localidad",],
    };
  },

  watch: {
    names(value) {
      if (value) this.names = value.toUpperCase();
    },
    lastNames(value) {
      if (value) this.lastNames = value.toUpperCase();
    },
    avatar(value) {
      if (value) this.avatar = value.toUpperCase();
    },
    responsibility(value) {
      if (value) this.responsibility = value.toUpperCase();
    },
    recommended(value) {
      if (value) this.recommended = value.toUpperCase();
    },

    employee(value) {
      if (value) {
        this.loadData();
        this.loadPayroll();
      }
    },

    district(value) {
      if (value) this.district = value.toUpperCase();
    },
  },

  methods: {
    process() {
      if (this.valid) {
        this.loadingProcess = true;
        setTimeout(() => {
          let payload = new FormData();
          payload.append("names", this.names);
          payload.append("last_names", this.lastNames);
          payload.append("avatar", this.avatar);
          payload.append("responsibility", this.responsibility);
          payload.append("recommended", this.recommended);
          payload.append("admission_date", this.date);
          payload.append("photo", this.photo);
          payload.append("enabled", parseInt(this.status));
          payload.append("location_id", this.locationId);
          payload.append("vehicule_ids", this.vehiIds);
          payload.append("salary", this.salary);
          payload.append("tools_ids", this.toolIds);
          payload.append("category_id", this.categoryId);
          payload.append("address", this.address);
          payload.append("district", this.district);

          if (this.schema != "new")
            payload.append("employeeId", this.employeeId);

          let path =
            this.schema == "new"
              ? "storeEmployeeAction"
              : "updateEmployeeAction";

          this.$store
            .dispatch(path, payload)
            .then((res) => {
              this.loadingProcess = false;
              this.clear();

              if (this.schema != "new") {
                let payload = {
                  action: "edit",
                  employeeId: this.employeeId,
                  employee: res,
                };
                
                this.$emit("closeDialogEmployee", payload);
              }
            })
            .catch(() => {
              this.loadingProcess = false;
            });
        }, 500);
      } else {
        this.$refs.form.validate();
      }
    },

    clear() {
      this.names = "";
      this.lastNames = "";
      this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.recommended = "";
      this.responsibility = "";
      this.photo = null;
      this.avatar = "";
      this.categoryId = 0;
      this.locationId = 0;
      this.salary = 0;
      this.status = 1;
      this.address = "";
      this.district = "";
      this.$refs.form.resetValidation();
    },

    loadData() {
      if (this.employee) {
        this.names = this.employee.names;
        this.lastNames = this.employee.last_names;
        this.avatar = this.employee.avatar;
        this.date = this.employee.admission_date;
        this.responsibility = this.employee.responsibility;
        this.recommended = this.employee.recommended;
        this.photoUrl = this.employee.photo_url;
        this.employeeId = this.employee.id;
        this.thumbUrl = this.employee.photo_thumb_url;
        this.status = this.employee.enabled;
        this.locationId = this.employee.location_id;
        this.salary = this.employee.salary;
        this.categoryId = this.employee.category ? this.employee.category.id : 0;
        this.address = this.employee.address;
        this.district = this.employee.district;
      }
    },

    closeDialogEmployee() {
      this.$emit("closeDialogEmployee", { action: null });
    },

    deleteEmployee() {
      this.$confirm({
        message: `Quieres eliminar este empleado?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDelete = true;

            setTimeout(() => {
              this.$store
                .dispatch("deleteEmployee", this.employeeId)
                .then(() => {
                  this.loadingDelete = false;

                  let payload = {
                    action: "delete",
                    employeeId: this.employeeId,
                  };
                  this.$emit("closeDialogEmployee", payload);
                });
            }, 5000);
          }
        },
      });
    },

    openDialogPhoto() {
      this.dialogPhoto = true;
    },

    loadLocations() {
      this.loadingLocation = true;
      setTimeout(() => {
        this.$store.dispatch("findLocations").then((res) => {
          this.locations = res;
          this.loadingLocation = false;
        });
      }, 500);
    },

    openDialogVehicules() {
      this.dialogVehicules = true;
      this.click++;
    },

    openDialogTools() {
      this.dialogTools = true;
      this.clickTool++;
    },

    vehiculesIds(ids) {
      this.dialogVehicules = false;
      this.vehiIds = ids;
    },

    toolsIds(ids) {
      this.toolIds = ids;
      this.dialogTools = false;
    },

    findEmployessCategories() {
      this.loadingCategories = true;

      setTimeout(() => {
        this.$store.dispatch('findEmployessCategoriesAction').then((res) => {
          this.categories = res;
          this.loadingCategories = false;
        })
      }, 500);

    },

    openDialogPayroll() {
      this.clickPayroll++;
      this.dialogPayroll = true;
    },

    closeDialogPayroll(res) {
      if (res) {
        if (res.action == "edit") {
          this.payroll = res;
          this.$emit("udpateEmployee", this.payroll);
        } else if (res.action == "delete") {
          this.$emit("deletePayroll", res);
        }
      }
      this.dialogPayroll = false;
    },

    loadPayroll() {
      this.loadingPayroll = true;
      if (this.employee && this.employee.payroll) {
        setTimeout(() => {
          this.$store.dispatch("payrollsFindByIdAction", { id: this.employee.payroll.id }).then((res) => {
            this.payroll = res;
            this.loadingPayroll = false;
          });
        }, 500);
      } else {
        this.loadingPayroll = false;
      }
    },

    openDialogAdminPayroll() {
      this.dialogAdminPayroll = true;
      this.loadingPayrolls = true;

      setTimeout(() => {
        this.$store.dispatch("payrollsFindAction").then((res) => {
          this.payrolls = res;
          this.loadingPayrolls = false;
        });
      }, 500);
    },

    selectPayroll(payroll) {
      this.$confirm({
        message: `Desea vincular el empleado a esta nomina?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingAsingPayroll = true;

            let payload = {
              payroll_id: payroll.id,
              employee_id: this.employee.id,
            }

            setTimeout(() => {
              this.$store.dispatch("assignEmployeeToPayrollAction", payload).then((res) => {
                this.loadingAsingPayroll = false;
                this.dialogAdminPayroll = false;
                this.$emit("remplaceEmployee", res);
              });
            }, 500);
          }
        },
      });
    },

    deleteOneEmployee(employee) {
      console.log(employee);

    }
  },
};
</script>
